import { Platform } from 'react-native'

import { Store } from '../general'

import type { Options } from './types'
import * as LocalStorage from './local'
import * as LocalStorageWeb from './local.web'
import * as SessionStorage from './session'
import * as SessionStorageWeb from './session.web'

export enum StorageKey {
  Language = 'lang',
  Email = 'email',
  Auth = 'auth',
  Companies = 'companies',
  Location = 'location',
  Building = 'building',
  Floor = 'floor',
  InsightsPeriod = 'insights:period',
  InsightsWeekdays = 'insights:weekdays',
  InsightsWorkingHours = 'insights:workinghours',
  WorkspaceFilter = 'workspace:filter',
  ProductFilter = 'product:filter',
  FloorZoom = 'floor:zoom',
}

type RootStore = object

class StorageStore extends Store<RootStore> {
  data: Record<string, any> = {}
  constructor(
    store: RootStore,
    readonly options?: Options,
  ) {
    super(store)
  }

  get(key: StorageKey | string, options?: Options, callback?: (value?: string) => void) {
    const allOptions = { ...this.options, ...options }
    const { session } = allOptions
    if (Platform.OS === 'web') {
      if (session) {
        const value = SessionStorageWeb.getItem(key, allOptions)
        callback?.(value || undefined)
        return value
      } else {
        const value = LocalStorageWeb.getItem(key, allOptions)
        callback?.(value || undefined)
        return value
      }
    } else {
      if (session) {
        SessionStorage.getItem(key, allOptions).then((value) => {
          callback?.(value || undefined)
        })
      } else {
        LocalStorage.getItem(key, allOptions).then((value) => {
          callback?.(value || undefined)
        })
      }
      return undefined
    }
  }

  set(key: StorageKey | string, data: string, options?: Options, callback?: () => void) {
    const allOptions = { ...this.options, ...options }
    const { session } = allOptions
    if (Platform.OS === 'web') {
      if (session) SessionStorage.setItem(key, data, allOptions)?.then(callback)
      else LocalStorage.setItem(key, data, allOptions)
      callback?.()
    } else {
      if (session) SessionStorage.setItem(key, data, allOptions)?.then(callback)
      else
        LocalStorage.setItem(key, data, allOptions)?.then(() => {
          callback?.()
        })
      this.data[key] = data
    }
  }

  delete(key: StorageKey | string, options?: Options, callback?: () => void) {
    const allOptions = { ...this.options, ...options }
    const { session } = allOptions
    if (Platform.OS === 'web') {
      if (session) SessionStorage.deleteItem(key, allOptions)
      else LocalStorage.deleteItem(key, allOptions)
      callback?.()
    } else {
      if (session) SessionStorage.deleteItem(key, allOptions)?.then(callback)
      else LocalStorage.deleteItem(key, allOptions)?.then(callback)
      delete this.data[key]
    }
  }
}

export default StorageStore
